// extracted by mini-css-extract-plugin
export var blue = "_3z-h";
export var brand = "_3z-d";
export var darkGrey = "_3z-g";
export var disabled = "_3z-6";
export var disabledSubtle = "_3z-7";
export var error = "_3z-8";
export var green = "_3z-i";
export var grey = "_3z-f";
export var icon = "_3z-0";
export var inherit = "_3z-c";
export var lightGrey = "_3z-e";
export var orange = "_3z-k";
export var pink = "_3z-m";
export var primary = "_3z-1";
export var purple = "_3z-n";
export var quaternary = "_3z-4";
export var quinary = "_3z-5";
export var red = "_3z-l";
export var secondary = "_3z-2";
export var success = "_3z-b";
export var tertiary = "_3z-3";
export var warning = "_3z-9";
export var warningSecondary = "_3z-a";
export var white = "_3z-o";
export var yellow = "_3z-j";